import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { navItems } from "./navItems";

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const runSearch = (value: string) => {
    const trimmed = value.trim();
    navigate(trimmed ? `/episodes?q=${encodeURIComponent(trimmed)}` : "/episodes");
    setMobileSearchOpen(false);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    runSearch(keyword);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <NavLink to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
              <i className="ri-cake-3-line"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-xl text-foreground-950">甜蜜惩罚动漫</span>
              <span className="hidden sm:block text-[11px] text-foreground-500 font-label">剧情 · 角色 · 观看指南</span>
            </span>
          </NavLink>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "bg-accent-100 text-accent-900"
                      : "text-foreground-600 hover:bg-background-200 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:block flex-1 max-w-xs">
            <form onSubmit={handleSubmit} className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索剧情或角色…"
                className="w-full pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-900 placeholder:text-foreground-400 font-label focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/40"
              />
            </form>
          </div>

          <div className="flex md:hidden items-center gap-2">
            <button
              type="button"
              aria-label="搜索"
              onClick={() => setMobileSearchOpen((prev) => !prev)}
              className="w-10 h-10 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 text-lg cursor-pointer"
            >
              <i className={mobileSearchOpen ? "ri-close-line" : "ri-search-line"}></i>
            </button>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMobileMenuOpen((prev) => !prev)}
              className="w-10 h-10 flex items-center justify-center rounded-md bg-background-100 text-foreground-700 text-lg cursor-pointer"
            >
              <i className={mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}></i>
            </button>
          </div>
        </div>

        {mobileSearchOpen && (
          <div className="md:hidden pb-3">
            <form onSubmit={handleSubmit} className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
              <input
                autoFocus
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索剧情或角色…"
                className="w-full pl-10 pr-3 py-3 text-base rounded-md bg-background-100 border border-background-300 text-foreground-900 placeholder:text-foreground-400 font-label focus:outline-none focus:border-primary-400"
              />
            </form>
          </div>
        )}

        {mobileMenuOpen && (
          <div className="md:hidden pb-3 grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                onClick={() => setMobileMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-3 rounded-md text-sm font-label transition-colors cursor-pointer ${
                    isActive ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-800"
                  }`
                }
              >
                <i className={`${item.icon} text-base`}></i>
                {item.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>

      <div className="md:hidden border-t border-background-200 bg-background-50">
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar px-4 py-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                  isActive ? "bg-accent-500 text-background-50" : "bg-background-100 text-foreground-700"
                }`
              }
            >
              <i className={`${item.icon} text-base`}></i>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </header>
  );
}